import { AppService } from '../../../@core/service/App.Service';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: "root",
  })
export class ClientService extends AppService<any> {

    constructor() {
        super('utclient');
     }
     async GetClientsCred(clientid:any){
      const result = await this.get('ClientsCredentials', [clientid])
      return result
      }
     async GetClientsData(clientid:any){
      const result = await this.get('Clients', [clientid])
      return result
      }
}
